import type { ExportColumn } from '@/components/ui'
import type { VendorItem } from '../api/types'

/**
 * CSV-export columns for the Vendor Pricelists module. Mirrors the
 * `customer-pricelists/utils/csv.ts` shape so the ExportDrawer behaves
 * identically. Stable keys — saved templates in localStorage under
 * `spi-ops:vendor-pricelists:export-templates` reference these.
 */

function _date(v: string | false | null | undefined): string {
  if (!v) return ''
  return String(v).slice(0, 10)
}

function _num(v: number | null | undefined): string {
  if (v === null || v === undefined) return ''
  return String(v)
}

export const COLUMNS: readonly ExportColumn<VendorItem>[] = [
  { key: 'product_name', header: 'Product', value: (r) => r.product_name ?? '' },
  { key: 'vendor_product_code', header: 'Vendor SKU', value: (r) => r.vendor_product_code ?? '' },
  { key: 'vendor_product_name', header: 'Vendor Product Name', value: (r) => r.vendor_product_name ?? '' },
  { key: 'product_variant_name', header: 'Product Variant', value: (r) => r.product_variant_name ?? '' },
  { key: 'min_qty', header: 'Min Qty', value: (r) => _num(r.min_qty) },
  { key: 'product_uom_name', header: 'Unit of Measure', value: (r) => r.product_uom_name ?? '' },
  { key: 'pack_size', header: 'Pack Size', value: (r) => _num(r.pack_size) },
  { key: 'price', header: 'Price', value: (r) => _num(r.price) },
  { key: 'discount', header: 'Discount (%)', value: (r) => _num(r.discount) },
  { key: 'currency_name', header: 'Currency', value: (r) => r.currency_name ?? '' },
  { key: 'lead_time_days', header: 'Lead (days)', value: (r) => _num(r.lead_time_days) },
  { key: 'incoterm', header: 'Incoterm', value: (r) => r.incoterm ?? '' },
  { key: 'agreement_name', header: 'Agreement', value: (r) => r.agreement_name ?? '' },
  { key: 'date_start', header: 'Valid From', value: (r) => _date(r.date_start) },
  { key: 'date_end', header: 'Valid To', value: (r) => _date(r.date_end) },
  { key: 'notes', header: 'Notes', value: (r) => r.notes ?? '' },
] as const

export const ALL_COLUMN_KEYS: readonly string[] = COLUMNS.map((c) => c.key)

export function slugForFilename(s: string): string {
  return (
    s
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 50) || 'untitled'
  )
}
